import {
  AppEnvSchema,
  getPublicEnv,
  NonCriticalUrlSchema,
} from "@sa-nu/env-vars";
import z from "zod";

/**
 * ブラウザ上で使う環境変数のスキーマ。
 * このスキーマに合致する環境変数が、ブラウザ上の window.publicEnv に埋め込まれる。
 */
const PublicEnvSchema = z.object({
  PUBLIC_APP_ENV: AppEnvSchema,
  PUBLIC_STRIPE_PUBLISHABLE_KEY: z.string().nonempty(),
  /**
   * イベントログ collector のオリジン。未設定・不正なら計測しない。Infisical は preview に
   * 空文字を配るうえ、ここで parse が落ちると全ページが 500 になるため。
   */
  PUBLIC_EVENT_COLLECTOR_ORIGIN: NonCriticalUrlSchema,
  OVERRIDE_CURRENT_TIME: z.string().optional(),
});

/** サーバ上では process.env から、ブラウザ上では HTML 中の script で window に埋め込まれたものを使う */
export const publicEnv = getPublicEnv(PublicEnvSchema);
